import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'cashflow-info',
    templateUrl: './cashflow-info.component.html',
    styleUrls: ['./cashflow-info.component.scss'],
})
export class CashflowInfoComponent implements OnInit {
    @Input() cashflowClosingDifference: number = 0;
    @Input() cashflowOpeningDifference: number = 0;
    constructor() {}

    ngOnInit(): void {}
}
